import React, { useState, useEffect, useRef } from "react";
import { useSettingsContext } from "../../../pages/admin/Settings/SettingsContext";

const Stepper = ({ steps, currentStep }) => {
  const [newStep, setNewStep] = useState([]);
  const stepsRef = useRef();
  const { scrollUpRef } = useSettingsContext();

  const updateStep = (stepNumber, steps) => {
    const newSteps = [...steps];
    let count = 0;
    while (count < newSteps.length) {
      //current step
      if (count === stepNumber) {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: true,
          selected: true,
          completed: true,
        };
        count++;
      }

      //step completed
      else if (count < stepNumber) {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: false,
          selected: true,
          completed: true,
        };
        count++;
      }
      //step pending
      else {
        newSteps[count] = {
          ...newSteps[count],
          highlighted: false,
          selected: false,
          completed: false,
        };
        count++;
      }
    }

    return newSteps;
  };

  useEffect(() => {
    const stepsState = steps.map((step, index) =>
      Object.assign(
        {},
        {
          description: step,
          completed: false,
          highlighted: index === 0 ? true : false,
          selected: index === 0 ? true : false,
        }
      )
    );

    stepsRef.current = stepsState;
    const current = updateStep(currentStep - 1, stepsRef.current);
    setNewStep(current);
  }, [steps, currentStep]);

  const stepsDisplay = newStep.map((step, index) => {
    return (
      <div
        key={index}
        className={
          index !== newStep.length - 1
            ? "w-full flex items-center"
            : "flex items-center"
        }
      >
        <div
          className="relative flex flex-col items-center text-indigo-700"
          ref={scrollUpRef}
        >
          <div
            className={`rounded-full transition-all duration-300 ease-in-out border-2 h-12 w-12 flex items-center justify-center py-3 group
              ${
                step.selected
                  ? "border-primary-600 bg-primary-600 text-white shadow-lg shadow-primary-200"
                  : step.completed
                  ? "border-primary-600 bg-primary-600 text-white"
                  : "border-gray-300 bg-white text-gray-500"
              }
              ${
                !step.completed && !step.selected
                  ? "hover:border-primary-200 hover:shadow-sm"
                  : ""
              }
            `}
          >
            {step.completed ? (
              <span className="text-primary-500 text-xl transform transition-transform duration-200 group-hover:scale-110">
                &#10003;
              </span>
            ) : (
              <span className="font-semibold transform transition-transform duration-200 group-hover:scale-110">
                {index + 1}
              </span>
            )}
          </div>
          <div
            className={`absolute top-0 text-center mt-16 w-32 text-xs font-medium uppercase transition-all duration-300
            transform-gpu
            sm:opacity-100 sm:scale-100
            ${step.highlighted ? "text-primary-700 font-bold" : "text-gray-500"}
            ${step.selected ? "scale-110" : "scale-100"}
            `}
          >
            {step.description}
          </div>
        </div>
        <div
          className={`flex-auto border-t-2 transition-all duration-300 ease-in-out ${
            step.completed ? "border-primary-600" : "border-gray-300"
          }`}
        ></div>
      </div>
    );
  });

  return (
    <div className="mx-4 p-6 flex justify-between items-center font-extrabold transition-all duration-300 bg-white rounded-lg shadow-sm">
      {stepsDisplay}
    </div>
  );
};
export default Stepper;
